<template>
    <div class="manage-section">
        <div class="header w1200 clearfix">
            <div class="header-left">
                <div class="hr"></div>
                <h2>透明管理</h2>
                <h3>SINCE 1961</h3>
            </div>
            <div class="header-right">Transparent</div>
        </div>
        <div class="text w1200">
            <p>如今，儿童安全成为家长最关心的问题。Kids 'R' Kids在中国的幼儿园沿用美国Kids 'R' Kids传统，在班与班之间使用全透明玻璃墙隔断，有效防范事故的发生。同时，每间教室都配有监控摄像头，家长可以实时查看孩子在园所中的情况。此外，我们有便捷的家校沟通系统，让校园管理更加透明化。</p>
        </div>
        <div class="main w1200">
            <div class="m_div div1">
                <div class="left">
                    <h2>玻璃墙设计</h2>
                    <p>大部分Kids 'R' Kids在中国的幼儿园的教室会采用透明玻璃墙隔断，良好的透光性不仅使教室看起来明亮、整洁，更是给孩子营造了一个开放的环境。老师、管理层能透过玻璃隔断，清晰地看到本班级和隔壁班级的情况，共同确保孩子的安全。不同年龄段的孩子也能通过玻璃隔断，熟悉相邻环境，轻松过渡班级。
                        <br>
                        <br>Kids 'R' Kids在中国的幼儿园采用与汽车挡风玻璃同类型的钢化玻璃。这种玻璃具有非常大的强度，即使发生破碎，也会变成无棱的碎玻璃，不会对孩子造成任何危害。
                    </p>
                </div>
                <div class="right">
                    <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/trans_img1.jpg">
                </div>
            </div>
            <div class="m_div div2">
                <div class="left">
                    <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/trans_img2.jpg">
                </div>
                <div class="right">
                    <h2>实时监控</h2>
                    <p>为了使家长能够更好地了解孩子的在校生活，Kids 'R' Kids在中国的幼儿园对校园进行24小时实时监控，家长可以通过客户端实时观察到孩子的动态，也进一步推动了校园的全透明化管理。</p>
                </div>
            </div>
            <div class="m_div div3">
                <div class="left">
                    <h2>家校沟通系统</h2>
                    <p>为了让家长及时了解孩子的心智发展状况，我们设置了完善的家校沟通系统。教师每日以电子版或者纸质版的形式，将针对每个孩子的Daily Report交给家长。在每个学期末，KRK还会为每个孩子进行TSG综合测评，在社交、体能、语言、认知、读写、数学等多个方面进行评估。</p>
                </div>
                <div class="right">
                    <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/trans_img3.jpg">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  components: {},
  methods: {}
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.manage-section {
  width: 100%;
  margin: 0 auto;
  background: rgba(246, 246, 246, 1);
  .w1200 {
    width: 1200px !important;
    margin: 0 auto 55px auto;
  }
  .header {
    // height: 155px;
    overflow: hidden;
    padding-top: 110px;
    // margin-bottom: 15px;
    .header-left {
      float: left;
      .hr {
        width: 96px;
        height: 4px;
        background: rgba(174, 149, 79, 1);
      }
      h2 {
        width: 375px;
        height: 96px;
        font-size: 48px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 96px;
      }
      h3 {
        width: 180px;
        height: 29px;
        line-height: 29px;
        background: rgba(174, 149, 79, 1);
        font-size: 24px;
        font-family: TimesNewRomanPS-BoldItalicMT;
        font-weight: bold;
        font-style: italic;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
    .header-right {
      float: left;
      width: 390px;
      margin-top: 16px;
      margin-left: 430px;
      height: 73px;
      font-size: 73px;
      font-family: TimesNewRomanPS-ItalicMT;
      font-style: italic;
      color: rgba(204, 204, 204, 1);
      line-height: 73px;
      text-align: right;
    }
  }
  .text {
    p {
      width: 883px;
      font-size: 16px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 32px;
    }
  }
  .main {
    margin-bottom: 0;
    padding-bottom: 216px;
    .m_div {
      height: 600px;
      background: #fff;
      text-align: center;
      .left {
        float: left;
      }
      .left,
      .right {
        width: 600px;
        height: 100%;
        display: inline-block;
      }
      .left h2,
      .right h2 {
        height: 29px;
        font-size: 30px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
      .left p,
      .right p {
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        margin: 0 auto;
        text-align: left;
      }
      .left img,
      .right img {
        width: 100%;
        right: 100%;
      }
    }
    .m_div.div1 {
      .left h2 {
        padding-top: 81px;
        padding-bottom: 55px;
      }
      p {
        width: 414px;
      }
    }
    .m_div.div2 {
      height: 350px;
      background: #fee17c;
      .right h2 {
        padding-top: 69px;
        padding-bottom: 65px;
      }
      p {
        width: 413px;
      }
    }
    .m_div.div3 {
      .left h2 {
        padding-top: 170px;
        padding-bottom: 55px;
      }
      p {
        width: 410px;
      }
    }
  }
}
@media (max-width: 767px) {
  .manage-section {
      padding-bottom: 40px;
    .w1200 {
      width: 100% !important;
    }
    .header {
      width: 100%;
      overflow: hidden;
      margin-top: 0;
      padding-top: 35px;
      .header-left {
        width: 100%;
        box-sizing: border-box;
        padding-left: 7.1%;
        .hr {
          width: 56px;
          height: 3px;
        }
        h2 {
          width: 100%;
          height: 41px;
          font-size: 21px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          font-family: PingFangSC-Medium;
          padding: 10px 0 8px;
          box-sizing: border-box;
        }
        h3 {
          width: 64px;
          height: 20px;
          font-size: 10px;
          font-family: TimesNewRomanPS-BoldItalicMT;
          font-weight: normal;
          line-height: 20px;
          background: rgba(174, 149, 79, 1);
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          padding: 0 5px;
        }
      }
      .header-right {
        display: none;
      }
    }
    .text {
      p {
        width: 100%;
        padding: 0 7.1%;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 28px;
      }
    }
    .main {
      width: 100%;
      box-sizing: border-box;
      padding: 0 7.1%;
      .m_div {
        background: #fff;
        text-align: center;
        padding-bottom: 25px;
        .left {
          clear: both;
        }
        .left,
        .right {
          width: 100%;
          height: auto;
          img {
            width: 100%;
            height: auto;
          }
        }
        .left h2,
        .right h2 {
          
          height: 25px;
          font-size: 21px;
          line-height: 25px;
        }
        .left p,
        .right p {
            box-sizing: border-box;
            padding: 0 5%;
          font-size: 13px;
          line-height: 21px;
          width: 100%;
        }
        .left img,
        .right img {
          width: 100%;
          right: 100%;
        }
      }
      .m_div.div1 {
        display: flex;
        flex-direction: column-reverse;
        height: 652px;
        .left h2 {
            padding-top: 25px;
          padding-bottom: 25px;
        }
      }
      .m_div.div2 {
        height: 375px;
        background: #fee17c;
        .right h2 {
          padding-top: 25px;
          padding-bottom: 25px;
        }
      }
      .m_div.div3 {
          height: 525px;
          display: flex;
        flex-direction: column-reverse;
        .left h2 {
          padding-top: 25px;
          padding-bottom: 25px;
        }
      }
    }
  }
}
@media (min-width: 376px) and (max-width: 414px) {
  .manage-section {
    .main {
      .m_div.div2 {
        height: 405px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/choose/manage.vue